<template>
	<div v-if="context">
		<nk-wrapper v-if="context.baugebiete" spacing="lg">
			<nk-list variant="overview">
				<nk-list-item
					v-for="(baugebiet, index) in context.baugebiete"
					:key="`${index}-baugebiet-${baugebiet.id}`"
				>
					<article>
						<nk-row vertical-gutter="2">
							<nk-col cols="full" order="2" sm="auto" order-sm="1">
								<nk-link :link="baugebiet.detailURL" block>
									<nk-title max-lines="2" size="lg" tag="h1">
										{{ baugebiet.titel }}
									</nk-title>
								</nk-link>
								<div
									v-if="baugebiet.einleitung"
									class="nk-cms-content text-md rfs-mb-3"
									v-html="baugebiet.einleitung"
								/>
								<nk-button
									:link="baugebiet.detailURL"
									variant="solid"
									tabindex="-1"
								>
									Weiterlesen
								</nk-button>
							</nk-col>
							<nk-col
								v-if="baugebiet.bild"
								cols="full"
								order="1"
								sm="4/12"
								order-sm="2"
							>
								<nk-link :link="baugebiet.detailURL" tabindex="-1">
									<nk-image
										:src="baugebiet.bild"
										:alt="baugebiet.bildtext"
										:copyright="baugebiet.bildcopyright"
										ar="3:2"
										image-class="w-full"
									/>
								</nk-link>
							</nk-col>
						</nk-row>
					</article>
				</nk-list-item>
			</nk-list>
		</nk-wrapper>
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

export default {
	name: 'NkTemplateBaugebieteOverview',

	mixins: [TemplatesDefault],

	computed: {
		activePageNumber() {
			return Number(this.$route.query.seite) || 1;
		},
	},
};
</script>
